var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5142 12.8203H29.4886C18.8677 12.8203 10.2578 21.4302 10.2578 32.0511V67.9485C10.2578 78.5694 18.8677 87.1793 29.4886 87.1793H70.5142C81.1351 87.1793 89.745 78.5694 89.745 67.9485V32.0511C89.745 21.4302 81.1351 12.8203 70.5142 12.8203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2544 29.4873H39.7416C33.3691 29.4873 28.2031 34.6532 28.2031 41.0258V61.5386C28.2031 67.9111 33.3691 73.077 39.7416 73.077H60.2544C66.6269 73.077 71.7929 67.9111 71.7929 61.5386V41.0258C71.7929 34.6532 66.6269 29.4873 60.2544 29.4873Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8439 48.7178H46.1516C43.3194 48.7178 41.0234 51.0137 41.0234 53.846V58.9742C41.0234 61.8064 43.3194 64.1024 46.1516 64.1024H53.8439C56.6762 64.1024 58.9722 61.8064 58.9722 58.9742V53.846C58.9722 51.0137 56.6762 48.7178 53.8439 48.7178Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5859 48.7181V43.5899C43.5859 39.7438 46.15 37.1797 49.9962 37.1797C53.8423 37.1797 56.4065 39.7438 56.4065 43.5899V48.7181",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0775 79.4871C79.45 79.4871 84.616 74.3211 84.616 67.9486C84.616 61.5761 79.45 56.4102 73.0775 56.4102C66.705 56.4102 61.5391 61.5761 61.5391 67.9486C61.5391 74.3211 66.705 79.4871 73.0775 79.4871Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0781 63.4619V72.4363",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5859 67.9482H77.5603",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultEmptyState);
export default __webpack_public_path__ + "static/media/vault_empty_state.f7e5ab4fe1fff18b8a4ee1a62de11ac1.svg";
export { ForwardRef as ReactComponent };